/* global acaiStoreLocator */

const dataFromWP = acaiStoreLocator;
const initialState = {
    locations: null,
};

if (dataFromWP) {
    initialState.locations = dataFromWP.locations;
}

export default initialState;
